import { useParams } from 'react-router-dom';
import { createRoute } from 'framework/routing';
import { LEADS_PATH } from 'domain/shared/lead';

export const useLeadRoute = () => {
  const baseRoutes = createRoute({ listRoute: LEADS_PATH });

  return {
    ...baseRoutes,
    convertRoute: `${baseRoutes.singleEntityRoute}/convert`,
    timelineRoute: `${baseRoutes.singleEntityRoute}/activities/:timelineEntryId?`,
  };
};

export const useLeadId = () => useParams<Dictionary<string>>().id!;
